// Module
var code = `<positionInfoView position="{{position}}" />

<terceraSeparator />

<div class="position-controls-container">
    <div class="order-edit-parameters">
        {{>orderEditControls orderEditParameterArray}}
    </div>
</div>

<terceraSeparator />`;
// Exports
export default code;